import "./AcademicOffer.module.css";
import Header from "@/reusable_sections/Header";
import OurTradesAndSpecialties from "./sections/OurTradesAndSpecialties";
import TrainingAreas from "./sections/TrainingAreas";
import Footer from "@/reusable_sections/Footer";
export default function AcademicOfferPage() {
  return <div>
      <Header />
      <OurTradesAndSpecialties />
      <TrainingAreas />
      <Footer />
    </div>;
}